import { render, staticRenderFns } from "./formulario_maestro.vue?vue&type=template&id=3f1fea53&lang=pug&"
import script from "./formulario_maestro.vue?vue&type=script&lang=js&"
export * from "./formulario_maestro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports